import type { Locale } from '@/i18n'

interface FooterCopy {
  brandLine: string
  locationLine: string
  /** Truthful as long as the site stays script-free: no analytics, no cookies, no embedded third parties. */
  privacyLine: string
}

export const FOOTER_COPY: Record<Locale, FooterCopy> = {
  en: {
    brandLine: 'Garlic Tech Kft · AI-native software studio · Est 2014',
    locationLine: 'Budapest · Working Globally',
    privacyLine:
      'This site sets no cookies and tracks no visitors. Data questions: contact@garlictech.com',
  },
  hu: {
    brandLine: 'Garlic Tech Kft. · AI-alapú fejlesztő stúdió · 2014 óta',
    locationLine: 'Budapest · Itthon és külföldön',
    privacyLine:
      'Ez az oldal nem használ sütiket és nem követi a látogatókat. Adatvédelmi kérdés: contact@garlictech.com',
  },
}
